interface Window {
  pageData: {
    devices: Array<{
      name: string;
      max_discount: string;
      size_options: Array<{
        name: string;
        price: string;
        discount: string;
        old_price: string;
      }>;
      color_options: Array<{
        name: string;
        hex: string;
      }>;
      link: string;
      video: string;
      image: string;
    }>;
    videoTimes: Array<{
      name: string;
      time: number;
    }>;
    video: {
      duration: number;
      prepromotionLink: string;
      prepromotionHlsLink: string;
      promotionLink: string;
      promotionHlsLink: string;
    };
  };
  promotionStartDate: Date;
}

function disableScroll() {
  window.addEventListener("scroll", preventScroll, { passive: false });
  disableTouchScrolling();
}

function enableScroll() {
  window.removeEventListener("scroll", preventScroll);
  enableTouchScrolling();
}

function preventScroll(event: Event) {
  event.preventDefault();
  event.stopPropagation();
  return false;
}

function disableTouchScrolling() {
  document.body.addEventListener("touchmove", preventDefault, {
    passive: false,
  });
}

function enableTouchScrolling() {
  document.body.removeEventListener("touchmove", preventDefault);
}

function preventDefault(event: Event) {
  event.preventDefault();
}

function videoPlayer(): {
  [x: string]: any;
  videoElement: HTMLVideoElement | null;
  currentTime: number;
  interval: number | null;
  videoDuration: number;
  isVideoPaused: boolean;
  isMuted: boolean;
  buffered: number;
  isDragging: boolean;
  volume: number;
  isVolumeDragging: boolean;
  _videoExpanded: boolean;
  isMobile: boolean;
  currentDeviceIndex: number;
  isVolumeBarOpen: boolean;
  volumeBarCloseTimeout: undefined | number;
  isUnmuted: boolean;
  isLiveStreamEnded: boolean;
  isVideoRestarted: boolean;
  isMetadataLoaded: boolean;
  isLive: boolean;
  currentDevice: any;
  latestDeviceIndex: number;
  isShowIconMobile: boolean;
  showIconMobileTimeout: undefined | number;
  init: () => void;
  setupVideoListener: () => void;
  startTracking: () => void;
  stopTracking: () => void;
  updateVideoTime: (index: number) => void;
  onProgress: () => void;
  onSeeked: () => void;
  handlePauseResume: () => void;
  handleMuteUnmute: (event: MouseEvent) => void;
  formatTime: (seconds: number) => string;
  updateProgressBar: () => number;
  updateVoumeBar: () => number;
  updateBufferBar: () => number;
  seekTo: (event: MouseEvent) => void;
  startDragging: (event: MouseEvent) => void;
  onDrag: (event: MouseEvent) => void;
  stopDragging: () => void;
  handleVolumeChange: (event: Event) => void;
  changeVolumeTo: (event: MouseEvent | TouchEvent) => void;
  startVolumeDragging: (event: MouseEvent | TouchEvent) => void;
  onVolumeDrag: (event: MouseEvent) => void;
  stopVolumeDragging: (event: MouseEvent) => void;
  clearVolumeBarCloseTimeout: () => void;
  startVolumeBarCloseTimeout: () => void;
  toogleVolumeBar: () => void;
  handleClick: (event: MouseEvent) => void;
  disableScroll: () => void;
  enableScroll: () => void;
  preventScroll: (event: Event) => boolean;
  disableTouchScrolling: () => void;
  enableTouchScrolling: () => void;
  preventDefault: (event: Event) => void;
} {
  return {
    videoElement: null,
    currentTime: 0,
    interval: null,
    videoDuration: 0,
    isVideoPaused: true,
    isMuted: true,
    buffered: 0,
    isDragging: false,
    volume: 0.5,
    isVolumeDragging: false,
    _videoExpanded: false,
    isMobile: window.innerWidth <= 768,
    currentDeviceIndex: 0,
    isVolumeBarOpen: false,
    volumeBarCloseTimeout: undefined,
    isUnmuted: false,
    isLiveStreamEnded: false,
    isVideoRestarted: false,
    isMetadataLoaded: false,
    latestDeviceIndex: 0,
    isShowIconMobile: false,
    showIconMobileTimeout: undefined,
    get videoExpanded() {
      return this._videoExpanded;
    },
    set videoExpanded(value) {
      this._videoExpanded = value;
      // if (value) {
      //   document.documentElement.classList.add("overflow-hidden");
      //   document.body.classList.add("overflow-hidden");
      // } else {
      //   document.documentElement.classList.remove("overflow-hidden");
      //   document.body.classList.remove("overflow-hidden");
      // }
    },
    get currentDevice() {
      return window.pageData.videoTimes[this.currentDeviceIndex];
    },
    get isLive() {
      return window.promotionStartDate < new Date();
    },

    // ############################################################################
    load() {
      console.log("loading hls");
      this.isLoading = true;
      const hls = new Hls({
        // Buffering configuration options
        maxBufferLength: 30, // Maximum buffer length (in seconds)
        maxBufferSize: 60 * 1000 * 1000, // Maximum buffer size in bytes (60MB)
        maxMaxBufferLength: 60, // Maximum maximum buffer length (in seconds)
        lowLatencyMode: false, // Set to true for lower latency mode
      });
      console.log("is PrePromotion", this.isPrePromotion);
      const streamUrl = this.isPrePromotion
        ? window.pageData.video.prepromotionHlsLink
        : window.pageData.video.promotionHlsLink;

      // If HLS.js is supported, load the stream
      if (Hls.isSupported()) {
        console.log("HLS.js is supported");
        hls.loadSource(streamUrl);
        hls.attachMedia(this.videoElement);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          // this.videoElement.play().catch((error) => {
          //   console.error("Error playing the video", error);
          //   this.fallbackToMP4();
          // });
          // this.isVideoPaused = false;
          console.log("manifest parsed");
        });
        hls.on(Hls.Events.ERROR, (event, data) => {
          console.error("HLS.js error:", data);
          if (!data.fatal) {
            switch (data.details) {
              case Hls.ErrorDetails.BUFFER_STALLED_ERROR:
                console.warn("Buffer stalled. Attempting recovery...");
                hls.startLoad(); // Restart fragment loading
                break;

              case Hls.ErrorDetails.FRAG_LOAD_ERROR:
                console.warn(
                  `Fragment load error for ${data.frag.url}. Retrying...`,
                );
                hls.startLoad();
                break;

              case Hls.ErrorDetails.FRAG_LOAD_TIMEOUT:
                console.warn("Fragment load timeout. Retrying...");
                hls.startLoad();
                break;

              default:
                console.warn("Non-fatal error:", data.details);
                break;
            }
          }

          if (data.fatal) {
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                console.error("Fatal network error encountered. Retrying...");
                hls.startLoad(); // Retry loading the stream
                break;

              case Hls.ErrorTypes.MEDIA_ERROR:
                if (data.details === "manifestIncompatibleCodecsError") {
                  console.error(
                    "Incompatible codecs error encountered. Falling back to MP4.",
                  );
                  this.fallbackToMP4();
                  hls.destroy();
                  break;
                }
                console.error(
                  "Fatal media error encountered. Attempting recovery...",
                );
                hls.recoverMediaError();
                break;

              default:
                console.error("Unrecoverable error. Falling back to MP4.");
                this.fallbackToMP4();
                hls.destroy();
                break;
            }
          }
        });

        if (!this.isVideoPaused) {
          this.videoElement?.play();
        }
      } else if (
        this.videoElement.canPlayType("application/vnd.apple.mpegurl")
      ) {
        console.log("Native HLS support detected");
        // Fallback for native HLS support (e.g., Safari)
        this.videoElement.src = streamUrl;
        if (!this.isVideoPaused) {
          this.videoElement.play();
        }
        // this.videoElement.play().catch((error) => {
        //   console.error("Error playing HLS natively", error);
        //   this.fallbackToMP4();
        // });
        // this.isVideoPaused = false;
      } else {
        console.error("HLS is not supported, falling back to MP4");
        this.fallbackToMP4();
      }
      this.isLoading = false;
    },

    // Fallback to MP4 if HLS fails
    fallbackToMP4() {
      const mp4Url = this.isPrePromotion
        ? window.pageData.video.prepromotionLink
        : window.pageData.video.promotionLink;
      this.videoElement.src = mp4Url;
      const sourceElement = document.createElement("source");
      sourceElement.src = mp4Url;
      sourceElement.type = "video/mp4";

      this.videoElement.innerHTML = ""; // Clear previous sources
      this.videoElement.appendChild(sourceElement);
      this.videoElement.load();
      console.log(this.videoElement);
      // this.videoElement.play().catch((error) => {
      //   console.error("Error playing MP4", error);
      // });
      // this.isVideoPaused = false;
    },

    // #############################################################################

    async init() {
      this.boundOnVolumeDrag = this.onVolumeDrag.bind(this);
      this.boundStopVolumeDragging = this.stopVolumeDragging.bind(this);
      this.disableScroll = this.disableScroll.bind(this);
      this.enableScroll = this.enableScroll.bind(this);
      this.preventScroll = this.preventScroll.bind(this);
      this.disableTouchScrolling = this.disableTouchScrolling.bind(this);
      this.enableTouchScrolling = this.enableTouchScrolling.bind(this);
      this.preventDefault = this.preventDefault.bind(this);
      const now = new Date();
      if (!window.promotionStartDate) {
        window.promotionStartDate = new Date("2025-01-29T11:00:00Z");
      }
      const passedTime =
        (now.getTime() - window.promotionStartDate.getTime()) / 1000;
      for (let i = window.pageData.videoTimes.length - 1; i >= 0; i--) {
        if (passedTime > window.pageData.video.duration) {
          this.latestDeviceIndex = window.pageData.videoTimes.length;
          break;
        }
        if (
          passedTime > window.pageData.videoTimes[i].time &&
          i > this.latestDeviceIndex
        ) {
          this.latestDeviceIndex = i;
          break;
        }
      }

      this.videoElement = this.$el.querySelector(
        "#product-video",
      ) as HTMLVideoElement;
      this.load();
      this.videoDuration = this.videoElement.duration;
      this.videoElement.volume = this.volume;
      this.setupVideoListener();
      window.addEventListener("resize", () => {
        this.isMobile = window.innerWidth <= 768;
        if (!this.isMobile) {
          this.videoExpanded = false;
        }
      });
      this.videoElement.addEventListener("loadedmetadata", () => {
        console.log("video metadata loaded");
        this.isMetadataLoaded = true;
        this.isVideoRestarted = false;
        if (this.videoElement) {
          this.videoElement.muted = this.isMuted;
          this.videoDuration = this.videoElement.duration;
          console.log(
            this.videoElement.duration,
            window.pageData.video.duration,
          );
          console.log(
            (new Date().getTime() - window.promotionStartDate.getTime()) / 1000,
          );
          const now = new Date();
          const passedTime =
            (now.getTime() - window.promotionStartDate.getTime()) / 1000;
          if (now > window.promotionStartDate) {
            if (passedTime < this.videoDuration) {
              this.videoElement.currentTime = passedTime;
              this.videoElement.play();
              this.isVideoPaused = false;
            } else {
              this.isLiveStreamEnded = true;
              this.videoElement.autoplay = false;
              if (!this.videoElement.paused) {
                this.videoElement.pause();
              }
              this.isVideoPaused = true;
              this.stopTracking();
              if (this.isMuted) {
                this.handleMuteUnmute(new MouseEvent("click"));
              }
            }
          } else {
            if (this.isMuted) {
              this.handleMuteUnmute(new MouseEvent("click"));
            }
          }
        }
      });

      this.videoElement.addEventListener("ended", () => {
        // this.videoElement?.load();
        this.load();
        this.isVideoPaused = true;
      });
    },

    setupVideoListener() {
      if (!this.videoElement) {
        return;
      }
      this.videoElement.addEventListener("play", () => {
        this.isVideoPaused = false;
        this.startTracking();
      });
      this.videoElement.addEventListener("pause", () => {
        this.isVideoPaused = true;
        this.stopTracking();
      });
      this.videoElement.addEventListener("seeked", () => {
        this.onSeeked();
      });
      this.videoElement.addEventListener("progress", () => {
        this.onProgress();
      });
      //this.startTracking();
    },

    startTracking() {
      this.interval = setInterval(() => {
        if (!this.videoElement) {
          return;
        }
        this.currentTime = this.videoElement.currentTime;
        for (let i = 0; i < window.pageData.videoTimes.length - 1; i++) {
          if (
            this.currentTime < window.pageData.videoTimes[i + 1].time &&
            this.currentTime > window.pageData.videoTimes[i].time &&
            this.currentDeviceIndex !== i
          ) {
            this.currentDeviceIndex = i;
            this.$dispatch("video-time-changed", { index: i });
          } else if (
            this.currentTime >
              window.pageData.videoTimes[window.pageData.videoTimes.length - 1]
                .time &&
            this.currentDeviceIndex !== window.pageData.videoTimes.length - 1
          ) {
            this.currentDeviceIndex = window.pageData.videoTimes.length - 1;
            this.$dispatch("video-time-changed", {
              index: window.pageData.videoTimes.length - 1,
            });
          }
        }

        const now = new Date();
        const passedTime =
          (now.getTime() - window.promotionStartDate.getTime()) / 1000;

        for (let i = window.pageData.videoTimes.length - 1; i >= 0; i--) {
          if (passedTime > window.pageData.video.duration) {
            this.latestDeviceIndex = window.pageData.videoTimes.length;
            break;
          }
          if (
            passedTime > window.pageData.videoTimes[i].time &&
            i > this.latestDeviceIndex
          ) {
            this.latestDeviceIndex = i;
            break;
          }
        }

        if (
          !this.isLiveStreamEnded &&
          !this.isVideoRestarted &&
          window.promotionStartDate < now &&
          passedTime >= this.videoElement.duration &&
          this.isMetadataLoaded
        ) {
          this.isLiveStreamEnded = true;
          this.videoElement.autoplay = false;
          if (!this.videoElement.paused) {
            this.videoElement.pause();
          }
          this.isVideoPaused = true;
          // this.videoElement.load();
          this.load();
          this.stopTracking();
        }
      }, 1000);
    },

    stopTracking() {
      clearInterval(this.interval || 0);
    },
    updateVideoTime(index) {
      if (!this.videoElement) {
        return;
      }
      //     const currentTime = Math.floor((new Date().getTime() - promotionStartDate.getTime()) / 1000)
      // if (currentTime / 10 < seekTime) bundan sonraki indexdeki productu secmek isteyende currentTime seek olunacaq
      const timeFromPromotionStart = Math.floor(
        (new Date().getTime() - window.promotionStartDate.getTime()) / 1000,
      );
      if (timeFromPromotionStart < window.pageData.videoTimes[index].time) {
        if (
          Math.abs(this.videoElement.currentTime - timeFromPromotionStart) < 3
        ) {
          return;
        }
        this.videoElement.currentTime = timeFromPromotionStart;
        for (let i = 0; i < window.pageData.videoTimes.length - 1; i++) {
          if (
            timeFromPromotionStart < window.pageData.videoTimes[i + 1].time &&
            timeFromPromotionStart > window.pageData.videoTimes[i].time &&
            this.currentDeviceIndex !== i
          ) {
            this.currentDeviceIndex = i;
          } else if (
            timeFromPromotionStart >
              window.pageData.videoTimes[window.pageData.videoTimes.length - 1]
                .time &&
            this.currentDeviceIndex !== window.pageData.videoTimes.length - 1
          ) {
            this.currentDeviceIndex = window.pageData.videoTimes.length - 1;
          }
        }
        return;
      }
      const newTime = window.pageData.videoTimes[index].time;
      this.currentDeviceIndex = index;
      this.videoElement.currentTime = newTime; // Set the video time
    },

    onProgress() {
      if (!this.videoElement) {
        return;
      }
      if (this.videoElement.buffered.length > 0) {
        this.buffered = this.videoElement.buffered.end(
          this.videoElement.buffered.length - 1,
        );
      }
    },

    onSeeked() {
      if (!this.videoElement) {
        return;
      }
      // When user manually seeks to a new position, update the device index
      const currentTime = this.videoElement.currentTime;
      let index = 0;
      for (let i = 0; i < window.pageData.videoTimes.length; i++) {
        if (currentTime >= window.pageData.videoTimes[i].time) {
          index = i;
        }
      }
      this.currentDeviceIndex = index;
      this.$dispatch("video-time-changed", { index: index });
    },

    handlePauseResume() {
      console.log("handlePauseResume", this.isVolumeDragging);
      if (!this.videoElement || this.isVolumeDragging) {
        return;
      }
      if (this.videoElement.paused) {
        this.videoElement.play();
        this.isVideoPaused = false;
      } else {
        this.videoElement.pause();
        this.stopTracking();
        this.isVideoPaused = true;
      }
      this.isVideoRestarted = true;
    },

    handleMuteUnmute(event) {
      event.stopPropagation();
      if (!this.videoElement) {
        return;
      }
      this.isUnmuted = true;
      this.videoElement.muted = !this.videoElement.muted;
      this.isMuted = this.videoElement.muted;
      if (!this.isMuted) {
        if (this.volume === 0) {
          this.volume = 0.5;
        }
        this.videoElement.volume = this.volume;
      } else {
        this.videoElement.volume = 0;
      }
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    },

    updateProgressBar() {
      return (this.currentTime / this.videoDuration) * 100;
    },

    updateVoumeBar() {
      if (this.isMuted) {
        return 0;
      }
      return this.volume * 100;
    },

    updateBufferBar() {
      return (this.buffered / this.videoDuration) * 100;
    },

    seekTo(event) {
      if (!this.videoElement) {
        return;
      }
      const progressBar = event.currentTarget;
      const progressBarElement = progressBar as HTMLElement;
      if (!progressBarElement) {
        return;
      }
      const clickPosition =
        (event.clientX - progressBarElement.getBoundingClientRect().left) /
        progressBarElement.offsetWidth;
      this.videoElement.currentTime = clickPosition * this.videoDuration;
    },

    // Handle dragging on the progress bar
    startDragging(event) {
      this.isDragging = true;
      this.seekTo(event); // Update currentTime immediately when dragging starts

      // Attach mousemove event to track dragging
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDragging);
    },

    // Update video time while dragging
    onDrag(event) {
      if (this.isDragging) {
        this.seekTo(event);
      }
    },

    // Stop dragging
    stopDragging() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDragging);
    },

    handleVolumeChange(event) {
      if (!this.videoElement) {
        return;
      }
      this.volume = Number((event.target as HTMLInputElement)?.value);
      this.videoElement.volume = this.volume; // Update video volume
      if (this.volume === 0) {
        this.isMuted = true; // If volume is 0, mute
      } else {
        this.isMuted = false; // Otherwise, unmute
      }
    },

    changeVolumeTo(event) {
      if (!this.videoElement) {
        return;
      }
      let clientY = 0;

      if (event instanceof MouseEvent) {
        clientY = event.clientY;
      } else if (event instanceof TouchEvent && event.touches.length > 0) {
        clientY = event.touches[0].clientY;
      }
      if (event.currentTarget !== document) {
        const progressBar = event.currentTarget;
        const progressBarElement = progressBar as HTMLElement;
        if (!progressBarElement) {
          return;
        }

        const clickPosition =
          (clientY - progressBarElement.getBoundingClientRect().top) /
          progressBarElement.offsetHeight;
        console.log(clickPosition);
        this.videoElement.volume = 1 - clickPosition;
        this.volume = this.videoElement.volume;
        this.clearVolumeBarCloseTimeout();
        this.startVolumeBarCloseTimeout();
      } else {
        const volumeDragPosition = clientY;
        const diff = volumeDragPosition - this.volumeDragStartPositon;
        const volumeChange = diff / 100;
        this.volume = Math.min(Math.max(this.volume - volumeChange, 0), 1);
        this.videoElement.volume = this.volume;
        this.volumeDragStartPositon = volumeDragPosition;
      }
      if (this.volume === 0) {
        this.isMuted = true;
        this.videoElement.muted = true;
      } else {
        this.isMuted = false;
        this.videoElement.muted = false;
      }
      this.isUnmuted = true;
    },

    startVolumeDragging(event) {
      this.isVolumeDragging = true;
      document.body.classList.add("select-none");
      this.disableScroll();

      console.log("started", event);
      this.changeVolumeTo(event); // Update currentTime immediately when dragging starts

      if (event instanceof MouseEvent) {
        this.volumeDragStartPositon = event.clientY;
      } else if (event instanceof TouchEvent && event.touches.length > 0) {
        this.volumeDragStartPositon = event.touches[0].clientY;
      }

      // Attach mousemove event to track dragging

      document.addEventListener("mousemove", this.boundOnVolumeDrag);
      document.addEventListener("mouseup", this.boundStopVolumeDragging);
      document.addEventListener("touchmove", this.boundOnVolumeDrag);
      document.addEventListener("touchend", this.boundStopVolumeDragging);

      this.clearVolumeBarCloseTimeout();
    },

    // Update video time while dragging
    onVolumeDrag(event) {
      if (this.isVolumeDragging) {
        this.changeVolumeTo(event);
      }
    },

    // Stop dragging
    stopVolumeDragging(e) {
      e.stopImmediatePropagation();

      console.log("stopped", e);
      this.isVolumeDragging = false;
      document.body.classList.remove("select-none");
      this.enableScroll();
      document.removeEventListener("mousemove", this.boundOnVolumeDrag);
      document.removeEventListener("mouseup", this.boundStopVolumeDragging);
      document.removeEventListener("touchmove", this.boundOnVolumeDrag);
      document.removeEventListener("touchend", this.boundStopVolumeDragging);
      this.startVolumeBarCloseTimeout();
    },

    clearVolumeBarCloseTimeout() {
      clearTimeout(this.volumeBarCloseTimeout);
    },
    startVolumeBarCloseTimeout() {
      this.clearVolumeBarCloseTimeout();
      this.volumeBarCloseTimeout = setTimeout(() => {
        this.isVolumeBarOpen = false;
      }, 5000);
    },
    toogleVolumeBar() {
      this.isVolumeBarOpen = !this.isVolumeBarOpen;
      this.startVolumeBarCloseTimeout();
    },
    handleClick(event) {
      this.isShowIconMobile = true;
      clearTimeout(this.showIconMobileTimeout);
      this.showIconMobileTimeout = setTimeout(() => {
        this.isShowIconMobile = false;
      }, 2000);
      if (this.isMobile && !this.videoExpanded) {
        if (window.promotionStartDate > new Date() || this.isVideoPaused) {
          return this.handlePauseResume();
        }
        return this.handleMuteUnmute(event);
      }
      if (
        ((this.isUnmuted || this.isVideoPaused) && !this.isLive) ||
        this.isVideoPaused
      ) {
        return this.handlePauseResume();
      }
      return this.handleMuteUnmute(event);
    },
    disableScroll() {
      window.addEventListener("scroll", this.preventScroll, { passive: false });
      this.disableTouchScrolling();
    },
    enableScroll() {
      window.removeEventListener("scroll", this.preventScroll);
      this.enableTouchScrolling();
    },
    preventScroll(event) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    },
    disableTouchScrolling() {
      document.body.addEventListener("touchmove", this.preventDefault, {
        passive: false,
      });
    },
    enableTouchScrolling() {
      document.body.removeEventListener("touchmove", this.preventDefault);
    },
    preventDefault(event) {
      event.preventDefault();
    },
  };
}

if (typeof window !== "undefined") {
  window.videoPlayer = videoPlayer;
}
